import { Card } from "react-bootstrap";
import BigStat from "./BigStat.jsx";
import styles from './StatCard.module.css';
import DataSource from "./DataSource.jsx";

function StatCard({title, time, disclaimer, dataSource, ...props}) {
  return (
    <>
      <Card className={styles.StatCard}>
        <Card.Body className={styles.StatCardBody}>
          <h4 className={styles.StatCardTitle}>{title}</h4>
          <BigStat {...props} />
          {time && (
            <div className={styles.StatCardTime}>
              {new Date(time).toLocaleString('en-AU')}
            </div>
          )}
          <div className={styles.StatCardDisclaimer}>
              {disclaimer}
          </div>
          <DataSource dataSource={dataSource} />
        </Card.Body>
      </Card>
    </>
  )
}

export default StatCard
